export { JSONAPIAdapter as default } from '@warp-drive/legacy/adapter/json-api';
